<div *ngIf="app?.isPlatformBrowserVar">
  <!-- Search Main -->
  <section class="home-section-five">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="banner-wrapper-five aos">
            <div class="section-search-five text-center" data-aos="fade-up" data-aos-duration="800">
              <span>{{ "Home.WorldsLargest" | translate }}</span>
              <h2>{{ "Home.SearchDoctorMakeanAppointment" | translate }}</h2>
              <p>{{ "Home.Discoverthebestdoctors" | translate }}</p>
              <div class="search-box-five">

                <form action="#">

                  <!-- Location Old -->
                  <!-- <i class="feather-user-check bficon"></i> -->
                  <!-- <div *ngIf="app?.isPlatformBrowserVar" class="search-input-five line-five serach">
                    <div class="form-group mb-0">
                      <input type="text" class="form-control search-ortho px-cut"
                        placeholder="{{ 'Home.enterLocation' | translate }}" ngx-google-places-autocomplete
                        [options]="options" (onAddressChange)="AddressChange($event)" />
                    </div>
                  </div> -->

                  <!-- Locations New -->
                  <div class="search-input-five line-five">
                    <div class="form-group mb-0">
                      <ng-select [items]="allLocations" bindLabel="nameForSelect" bindValue="id"
                        placeholder="{{ 'Home.enterLocation' | translate }}" appendTo="body" [multiple]="false"
                        [(ngModel)]="allLocationsValues">
                      </ng-select>
                    </div>
                  </div>


                  <!-- HealthCareInsurance -->
                  <div class="search-input-five line-five">
                    <div class="form-group mb-0">
                      <ng-select [items]="HealthCareInsurance" bindLabel="name" bindValue="id"
                        placeholder="{{ 'Home.HealthCareInsurance' | translate }}" appendTo="body" [multiple]="false"
                        [(ngModel)]="HealthCareInsuranceValue">
                      </ng-select>
                    </div>
                  </div>

                  <!-- MedicalInsurance -->
                  <div class="search-input-five line-five">
                    <div class="form-group mb-0">
                      <ng-select [items]="MedicalServices" bindLabel="name" bindValue="id"
                        placeholder="{{ 'Home.MedicalInsurance' | translate }}" appendTo="body" [multiple]="false"
                        [(ngModel)]="MedicalServicesValue">
                      </ng-select>
                    </div>
                  </div>


                  <!-- DoctorName -->
                  <div class="search-input-five line-five">
                    <div class="form-group mb-0">
                      <ng-select [items]="Doctors" bindLabel="fullName" bindValue="fullName" labelForId="docSelect"
                        [loading]="docsLoading" (keyup)="debounceForDocName($event)"
                        placeholder="{{ 'Home.doctorName' | translate }}" appendTo="body" [multiple]="false"
                        [(ngModel)]="DoctorsValue">
                      </ng-select>
                    </div>
                  </div>

                  <!-- [routerLink]="'/patients/search-doctor'" -->

                  <div class="">
                    <!-- (click)="searchDoctorsOld()" -->
                    <a (click)="searchDoctorsNew()" class="btn search_service search-bt" type="submit">{{ "Home.Search"
                      |
                      translate }}</a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Search Main -->

  <!-- Services  -->
  <section class="clinic-section-five">

    <div class="container mt-5">
      <div class="overview-box mt-5">
        <div class="row h-100 align-items-center">
          <div class="col-lg-12 col-md-12 col-sm-12 overview-content">
            <h2 class="ihospital-title mb-5" style="text-align: center !important;font-size: 27px;
              font-weight: 700;" data-aos="fade-up" data-aos-duration="800">
              {{ "about.ourServices" | translate }}
            </h2>

            <div class="container d-flex h-100" style="justify-content: center !important">
              <div class="justify-content-center align-self-center min-h-sevices"
                style="text-align: center !important; width: 85% !important">

                <!-- <div class="row" style="justify-content: center">
                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service1.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name" data-aos="fade-up"
                        data-aos-duration="800">
                        {{ "about.physicians" | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service2.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.nurse" | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service9.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.physicalTherapy" | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service4.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.vaccines" | translate }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="row" style="justify-content: center">
                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service6.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.dentalCare" | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service7.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.medicalEquipmentRental" | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service8.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.nutritionalGuidance" | translate }}
                      </p>
                    </div>
                  </div>

                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service3.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.laboratory" | translate }}
                      </p>
                    </div>
                  </div>

                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service11.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.xray" | translate }}
                      </p>
                    </div>
                  </div>
                  <div class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim">
                    <div class="row" style="justify-content: center !important">
                      <img data-aos="fade-up" data-aos-duration="800" src="./assets/img/service5.png" alt=""
                        loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name">
                        {{ "about.otherMedicalServices" | translate }}
                      </p>
                    </div>
                  </div>
                </div> -->

                <div class="row" style="justify-content: center">

                  <div *ngFor="let item of homeServicesRes"
                    class="service-col col-xl-3 col-lg-3 col-md-3 col-sm-6 res-less-576 anim mb-4 cursor-pointer"
                    (click)="routeToServiceDetails(item.id)">
                    <div class="row" style="justify-content: center !important">
                      <img class="serviceSize mb-4" data-aos="fade-up" data-aos-duration="800"
                        [src]="app.getUserImage2(item?.image)" alt="" loading="lazy" />
                    </div>
                    <div class="row" style="justify-content: center !important">
                      <p data-aos="fade-up" data-aos-duration="800" class="srv-Name" data-aos="fade-up"
                        data-aos-duration="800">
                        {{ item?.serviceName }}
                      </p>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </section>
  <!-- /Services  -->

  <!-- Best Doctors -->
  <section class="best-section-five">
    <div class="container max-w-1445">
      <div class="row">
        <div class="col-md-12">
          <div class="section-header section-header-five text-center aos d-flex px-3 mb-3">
            <h2 data-aos="fade-up" data-aos-duration="800" class="title-five">{{ "Home.BookOurBestDoctor" | translate }}
            </h2>
          </div>
        </div>
      </div>

      <div class="row m-h-G">
        <ngx-slick-carousel [ngClass]="this.app?.getUserLanguage() == 'en' ? 'EnCar' : 'ArCar'"
          class="col-lg-2 col-md-4 d-flex aos w-100" #slickModal="slick-carousel" [config]="slideConfigureForDoctor">
          <!-- *ngFor="let doctor of DoctorsTopRated | slice: 50:58" -->
          <div data-aos="fade-up" data-aos-duration="800" class="slick-slide mx-3 card p-3 box-shadow"
            *ngFor="let doctor of DoctorsTopRated" ngxSlickItem>
            <div class="d-flex mb-3">
              <div class=" d-inline-block mx-2">
                <!-- <ngx-skeleton-loader class="d-block" *ngIf="!imgLoadForDoctors" count="1" appearance="circle" [theme]="{ 
                  height: '90px',
                  width : '90px',
                  position: 'sticky',
                  margin: '0px'
                }"></ngx-skeleton-loader> -->
                <!-- (load)="loadImageForBestDoctors($event)" -->
                <!-- [hidden]="imgLoadForDoctors === false" -->
                <a class="cursor-pointer" (click)="app.routeToDoctorProfile(doctor)">
                  <!-- <img [src]="app.getImageFile(doctor.picture)" class="w-h-forMap" loading="lazy" /> -->
                  <img title="{{doctor?.fullName | splitStringToArEn}} - {{ doctor?.speciality | splitStringToArEn }}"
                    class="w-h-forMap" [src]="app.getUserImage2(doctor?.picture)"
                    alt="{{doctor?.fullName | splitStringToArEn}} - {{ doctor?.speciality | splitStringToArEn }}" />
                  <!-- <app-img-loader [className]="'bestDoc'" [src]="doctor?.picture"></app-img-loader> -->
                </a>
              </div>
              <div class="d-inline-block">
                <p class="doc-name-card mb-1  mt-2">{{doctor?.fullName | splitStringToArEn}}</p>
                <p class="doc-spech-card m-0 mb-1 d-block">{{doctor?.speciality | splitStringToArEn}}</p>
                <p class="doc-loc-card m-0">{{doctor?.country?.name}}, {{doctor?.city}}</p>
              </div>


            </div>

            <div class="row">
              <div class="col-12">
                <!-- <span class="mx-1 start-icon"><i class="fa fa-star"></i></span> -->
                <p class="rate-card">
                  <img *ngIf="doctor?.rate" class="star-icon d-inline-block" src="assets/img/star2.svg" alt="" />
                  <span *ngIf="doctor?.rate" class="mx-1 rateP d-inline-block">{{doctor?.rate}}</span>
                </p>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-12">
                <span class="about-card-doc">
                  "{{doctor?.about| customSplit}}"
                </span>
              </div>
            </div>

            <div class="row cur-pointer" (click)="app.routeToDoctorProfile(doctor)">
              <div class="col-12 d-f-just">
                <span class="viewPro">{{ "Home.viewProfile" | translate }}</span>
                <span *ngIf="this.app?.getUserLanguage() == 'en'" class="right-angle"><i
                    class="fa fa-angle-right"></i></span>
                <span *ngIf="this.app?.getUserLanguage() == 'ar'" class="right-angle"><i
                    class="fa fa-angle-left"></i></span>
              </div>
            </div>



          </div>
        </ngx-slick-carousel>
      </div>

      <div class="doctor-see-btn text-center aos">
        <button data-aos="fade-up" data-aos-duration="800" (click)="app?.mainRouteToSearchComponent()"
          class="btn see-all-btn">{{
          "Home.SeeAllDoctors" | translate
          }}</button>
      </div>
    </div>
  </section>
  <!-- /Best Doctors  -->

  <!-- Latest Blogs  -->
  <section class="blog-section-five">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-header section-header-five text-center aos">
            <h2 data-aos="fade-up" data-aos-duration="800" class="title-five">{{ "Home.OurLatestBlogs" | translate }}
            </h2>
          </div>
        </div>
      </div>
      <div class="row justify-content-center m-h-55">
        <div data-aos="fade-up" data-aos-duration="800" class="col-lg-4 col-md-6 d-flex aos"
          *ngFor="let blog of LatestBlogs | slice: 0:3">
          <div class="blog-grid-five w-100">
            <div class="blog-five-img">
              <!-- <img loading="lazy" [src]="app.getImageFile(blog?.image)" class="img-fluid blog-details-img"/> -->
              <app-img-loader [className]="'blogHome'" [src]="blog?.image"></app-img-loader>
              <div class="blog-item-info">
                <div class="blog-news-date">
                  <a [routerLink]="'/' + this?.app?.languageCode + '/blog'">
                    <i class="feather-calendar me-2"></i>
                    <span> {{ blog?.createdAt | slice: 0:10 }} </span>
                  </a>
                </div>
                <!-- <div class="blog-doctors-profile">
                                    <a [routerLink]="'/blog'">
                                        <img src="assets/img/doctors/doctor-thumb-01.jpg" alt="" class="me-2">
                                        <span> {{ blog?.title }} </span>
                                    </a>
                                </div> -->
              </div>
            </div>
            <div class="blog-info-five">
              <h3 class="blog-news-title cursor-pointer">
                <a (click)="app.routeToBlogDetails(blog,blog?.id)">{{ blog?.title }}</a>
              </h3>
              <!-- <p>{{ blog?.description | slice: 0:150 }} ....</p> -->
              <a (click)="app.routeToBlogDetails(blog,blog?.id)" class="read-news cursor-pointer">{{
                "Home.ReadNews" | translate
                }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center">
          <div class="blog-five-btn aos">
            <a data-aos="fade-up" data-aos-duration="800" [routerLink]="'/' + this?.app?.languageCode + '/blog'"
              class="btn blog-view">{{
              "Home.ViewMore" | translate
              }}</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Latest Blogs  -->

  <!-- Download Our App  -->
  <section class="blog-section-five bg-b-light">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 py-5">
          <div class="row">
            <div class="col-12">
              <div class="row mb-4">
                <h1 data-aos="fade-up" data-aos-duration="800" class="dw-app f-poopins">
                  {{ "Home.downloadApp" | translate }}
                </h1>
              </div>
              <div class="row mb-4">
                <p data-aos="fade-up" data-aos-duration="800" class="info-app">{{ "Home.appSectionInfo" | translate }}
                </p>
              </div>
              <div class="row mb-4">
                <div class="col-12 mb-3">
                  <a data-aos="fade-up" data-aos-duration="800" class="splash-img-app"
                    href="https://apps.apple.com/us/app/ihospital-home-healthcare/id1515967546" target="_blank"
                    rel="noopener noreferrer">
                    <img loading="lazy" src="assets/app-store.png" class="wow fadeInDown splash-img-app" />
                  </a>
                </div>
                <div class="col-12">
                  <a data-aos="fade-up" data-aos-duration="800" class="splash-img-app"
                    href="https://play.google.com/store/apps/details?id=com.technzone.ihospital" target="_blank"
                    rel="noopener noreferrer">
                    <img loading="lazy" src="assets/google-play.png" class="wow fadeInDown splash-img-app1 ml-5p" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex">
          <img loading="lazy" data-aos="fade-up" data-aos-duration="800" src="assets/SplashPage-2.png"
            style="display: block;" class="wow splash-img my-auto" />
        </div>
      </div>
    </div>
  </section>
  <!-- /Download Our App  -->
</div>

<!-- <SSR> -->
<div *ngIf="app?.isPlatformServerVar"
  style="display: none !important;visibility:hidden !important;opacity: 0 !important;">
  <!-- <SSR> -->
  <div style="display: none;visibility:hidden;opacity: 0;" *ngIf="route?.url?.includes('/en/')">
    <p>Future of Healthcare</p>
    <p>Search for a Doctor, Make an Appointment</p>
    <p>Discover the best doctors in your city</p>
  </div>
  <!-- </SSR> -->

  <!-- <SSR> -->
  <div style="display: none;visibility:hidden;opacity: 0;">
    <h4 *ngFor="let item of HealthCareInsurance">{{item.name}}</h4>
  </div>
  <!-- </SSR> -->

  <!-- <SSR> -->
  <div style="display: none;visibility:hidden;opacity: 0;" *ngIf="route?.url?.includes('/ar/')">
    <p>مستقبل الرعاية الصحية</p>
    <p>ابحث عن طبيب ، حدد موعد</p>
    <p>اكتشف أفضل الأطباء والعيادات في المدينة الأقرب إليك.</p>
  </div>
  <!-- </SSR> -->

  <!-- <SSR> -->
  <div style="display: none;visibility:hidden;opacity: 0;">
    <h4 *ngFor="let item of MedicalServices">{{item.name}}</h4>
  </div>
  <!-- </SSR> -->

  <!-- <SSR> -->
  <div *ngIf="route?.url?.includes('/ar/')" style="display: none;visibility:hidden;opacity: 0;">
    <p>أهم التخصصات التي تم البحث عنها</p>
    <p>0789642222</p>
  </div>

  <div *ngIf="route?.url?.includes('/en/')" style="display: none;visibility:hidden;opacity: 0;">
    <p>Top searched specialties</p>
    <p>0789642222</p>
  </div>
  <!-- </SSR> -->

  <!-- <SSR> -->
  <div style="display: none;visibility:hidden;opacity: 0;">
    <h4 *ngFor="let item of homeServicesRes">{{item?.serviceName}}</h4>
  </div>
  <!-- </SSR> -->


  <!-- <SSR> -->
  <div style="display: none;visibility:hidden;opacity: 0;" *ngIf="app.isPlatformServerVar">
    <p>0789642222</p>
    <p *ngIf="route?.url?.includes('/en/')">Book Our Best Doctors</p>
    <p *ngIf="route?.url?.includes('/ar/')">احجز عند أفضل الأطباء لدينا</p>
  </div>
  <!-- </SSR> -->

  <div *ngFor="let doctor of DoctorsTopRated">
    <img title="{{doctor?.fullName}} - {{ doctor?.speciality }}" [src]="app.getUserImage2(doctor?.picture)"
      alt="{{doctor?.fullName}} - {{ doctor?.speciality }}" />
    <p>{{doctor?.fullName}}</p>
    <p>{{ doctor?.speciality}}</p>
    <p>{{doctor?.country?.name}}, {{doctor?.city}}</p>
    <p>{{doctor?.rate}}</p>
    <p>{{doctor?.about}}</p>
  </div>

  <!-- <SSR> -->
  <div *ngIf="app.isPlatformServerVar" style="display: none;visibility:hidden;opacity: 0;">
    <p *ngIf="route?.url?.includes('/en/')">Our Latest Blogs</p>
    <p *ngIf="route?.url?.includes('/ar/')">أخر المقالات</p>
  </div>
  <!-- </SSR> -->

  <div *ngFor="let blog of LatestBlogs">
    <p> {{ blog?.createdAt | slice: 0:10 }} </p>
    <p> {{ blog?.description | slice: 0:150 }} </p>
    <p> {{ blog?.title }} </p>
  </div>

  <!-- <SSR> -->
  <div *ngIf="app.isPlatformServerVar" style="display: none;visibility:hidden;opacity: 0;">
    <p>0789642222</p>
    <p *ngIf="route?.url?.includes('/en/')">Download our app</p>
    <p *ngIf="route?.url?.includes('/ar/')">قم بتنزيل تطبيقنا</p>
    <p *ngIf="route?.url?.includes('/en/')">At iHospital we connect you to professional and highly
      qualified
      doctors, nurses and physiotherapists available around the clock to cater to your medical needs and
      provide you with the best medical care wherever you are</p>
    <p *ngIf="route?.url?.includes('/ar/')">في iHospital ، نقوم بتوصيلك بالأطباء والممرضات وأخصائيي العلاج
      الطبيعي
      المحترفين والمؤهلين تأهيلاً عالياً المتاحين على مدار الساعة لتلبية احتياجاتك الطبية وتزويدك بأفضل
      رعاية
      طبية أينما كنت"</p>
  </div>
  <!-- </SSR> -->

</div>
<!-- </SSR> -->